import { CreateInstance } from "./config"
const MyDevicesAPI = CreateInstance("my-devices")
export default MyDevicesAPI
